/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './product-tag.reducer';

export const ProductTagDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const productTagEntity = useAppSelector(state => state.productTag.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="productTagDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.productTag.detail.title">ProductTag</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.productTag.id">Id</Translate>
            </span>
          </dt>
          <dd>{productTagEntity.id}</dd>
          <dt>
            <span id="productId">
              <Translate contentKey="tinyMedicRestApp.productTag.productId">Product Id</Translate>
            </span>
          </dt>
          <dd>{productTagEntity.productId}</dd>
          <dt>
            <span id="productType">
              <Translate contentKey="tinyMedicRestApp.productTag.productType">Product Type</Translate>
            </span>
          </dt>
          <dd>{productTagEntity.productType}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.productTag.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{productTagEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.productTag.active">Active</Translate>
            </span>
          </dt>
          <dd>{productTagEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.productTag.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{productTagEntity.cursor}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.productTag.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{productTagEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.productTag.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{productTagEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.productTag.tag">Tag</Translate>
          </dt>
          <dd>{productTagEntity.tag ? productTagEntity.tag.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/product-tag" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/product-tag/${productTagEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ProductTagDetail;
